import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import ParticlesBackground from './ParticlesBackground';
import AppNavbar from './Navbar';
import ZoomableChart from './ZoomableChart';
import './Models.css';

const Models = () => {
    const { isAuthenticated, loading, error, setError, login } = useAuth();
    const [localEmail, setLocalEmail] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        await login(localEmail);
    };

    if (loading) {
        return (
            <div className="models-page">
                <header className="models-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content">
                        <h1>Entropy</h1>
                    </div>
                </header>
                
                <main className="models-main">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <p>Loading...</p>
                        </div>
                    </div>
                </main>

                <footer className="models-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="models-page">
                <header className="models-header">
                    <AppNavbar />
                    <ParticlesBackground />
                    <div className="header-content">
                        <h1>Entropy</h1>
                    </div>
                </header>
                
                <main className="models-main">
                    <div className="container">
                        <div className="chart-container">
                            {/* Blurred preview */}
                            <div style={{ filter: 'blur(8px)', pointerEvents: 'none' }}>
                                <div className="chart-grid-fullwidth">
                                    <div className="chart-card" style={{ padding: '1rem 1rem 0.5rem' }}>
                                        <h3>S&P 500 (SPX)</h3>
                                        <div className="chart-wrapper">
                                            <ZoomableChart skipAuth={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Login overlay positioned over blurred content */}
                            <div className="login-overlay">
                                <h2>Subscriber Login</h2>
                                <p>Enter your email to access the site.</p>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={localEmail}
                                        onChange={(e) => setLocalEmail(e.target.value)}
                                        required
                                    />
                                    <button type="submit">Login</button>
                                </form>
                                {error && <p className="error-message">{error}</p>}

                                <iframe
                                    src="https://machinaquanta.substack.com/embed"
                                    title="Substack Subscription Login"
                                    style={{ width: '100%', maxWidth: '480px', height: '320px', border: 'none' }}
                                    scrolling="no"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </main>

                <footer className="models-footer">
                    <div className="container">
                        <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        );
    }

    return (
        <div className="models-page">
            <header className="models-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content">
                    <h1>Entropy</h1>
                </div>
            </header>

            <main className="models-main">
                <div className="container">

                    {/* All 3 indices side by side */}
                    <div className="chart-grid-3col">
                        <div className="chart-card" style={{ padding: '1rem 1rem 0.5rem' }}>
                            <h3>S&P 500 (SPX)</h3>
                            <div className="chart-wrapper">
                                <ZoomableChart skipAuth={true} />
                            </div>
                        </div>
                        <div className="chart-card" style={{ padding: '1rem 1rem 0.5rem' }}>
                            <h3>NASDAQ 100 (NDX)</h3>
                            <div className="chart-wrapper">
                                <ZoomableChart ticker="NDX" skipAuth={true} />
                            </div>
                        </div>
                        <div className="chart-card" style={{ padding: '1rem 1rem 0.5rem' }}>
                            <h3>Russell 2000 (RUT)</h3>
                            <div className="chart-wrapper">
                                <ZoomableChart ticker="RUT" skipAuth={true} />
                            </div>
                        </div>
                    </div>

                </div>
            </main>

            <footer className="models-footer">
                <div className="container">
                    <p>&copy; 2023-{new Date().getFullYear()} machinaquanta.com. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Models;